import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = {
  class: "input-form-label",
  for: "folder-title"
}
const _hoisted_4 = { class: "flex gap-3" }

import { ref, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import Button from "@/components/common/Button.vue";
import { DocumentFolderDataService } from "@/services";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: { type: Boolean, default: false },
  parentFolderId: { type: String as () => string | null, default: null },
},
  setup(__props, { emit }: { emit: ({ hide: []; submit: [] }), expose: any, slots: any, attrs: any }) {

const props = __props





const toast = useToast();
const title = ref("");
const loading = ref(false);

watch(
  () => props.show,
  (visible) => {
    if (visible) title.value = "";
  }
);

async function handleSubmit() {
  if (!title.value.trim()) return;
  loading.value = true;
  try {
    const response = await DocumentFolderDataService.create({
      title: title.value.trim(),
      parentFolderId: props.parentFolderId,
    });
    toast.success(response.data.message);
    emit("submit");
    emit("hide");
  } catch (error: any) {
    toast.error(error.response?.data?.message || t("common.error"));
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    title: _unref(t)('archive.createFolder'),
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)("common.title")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "folder-title",
            type: "text",
            class: "input-form w-full",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, title.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Button, {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('hide')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(Button, {
            type: "submit",
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.create")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["show", "title"]))
}
}

})